import buildSubjectApiPath from '@Application/Subjects/buildSubjectApiPath';
import type * as React from 'react';
import interviewConsentFetched, {
	type InterviewConsentFetchedAction,
	type InterviewConsentPayload,
} from '@Application/Beneficiaries/Interviews/Actions/interviewConsentFetched';
import interviewConsentFetchFailed, {
	type InterviewConsentFetchFailedAction,
} from '@Application/Beneficiaries/Interviews/Actions/interviewConsentFetchFailed';
import type FetchInterviewConsent from '@Application/Beneficiaries/Interviews/Queries/FetchInterviewConsent';
import { get } from '@Domain/Api';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';

type Actions = InterviewConsentFetchedAction | InterviewConsentFetchFailedAction;

export default (query: FetchInterviewConsent) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await get<InterviewConsentPayload>(
				`${buildSubjectApiPath(query.facilityId, query.subject)}/interviews/${query.interviewId}/consent`,
			);

			const action = interviewConsentFetched(payload, query.interviewId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = interviewConsentFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
